import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import FolderChild from './child/FolderChild';
import EntityChild from './child/EntityChild';
import OrderButtons from 'common/components/OrderButtons';

const childUrl = node => {
  if (node.product) {
    return `/products/${node.product}`;
  } else if (node.pest) {
    return `/pests/${node.pest}`;
  } else if (node.tip) {
    return `/tips/${node.tip}`;
  } else if (node.memo) {
    return `/memos/${node.memo}`;
  } else {
    return null;
  }
};

class NodeChild extends React.Component {
  static propTypes = {
    node: PropTypes.object.isRequired,
    nodeCount: PropTypes.number.isRequired,
    moveUpNode: PropTypes.func.isRequired,
    moveDownNode: PropTypes.func.isRequired,
    deleteNode: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.moveUp = this.moveUp.bind(this);
    this.moveDown = this.moveDown.bind(this);
    this.delete = this.delete.bind(this);
  }

  moveUp() {
    this.props.moveUpNode(this.props.node);
  }

  moveDown() {
    this.props.moveDownNode(this.props.node);
  }

  delete() {
    this.props.deleteNode(this.props.node);
  }

  get child() {
    const { node } = this.props;
    if (node.product || node.pest || node.tip || node.memo) {
      return EntityChild;
    } else {
      return FolderChild;
    }
  }

  get orderer() {
    const { node, nodeCount } = this.props;

    return (
      <OrderButtons
        canMoveUp={node.order > 1}
        moveUp={this.moveUp}
        canMoveDown={node.order < nodeCount}
        moveDown={this.moveDown}
      />
    );
  }

  render() {
    const { node } = this.props;

    return React.createElement(this.child, {
      node,
      entityUrl: childUrl,
      orderer: this.orderer,
      onDelete: this.delete,
    });
  }
}

export default pure(NodeChild);



// WEBPACK FOOTER //
// ./src/modules/catalog/components/NodeChild.js